/* eslint-env browser */
import request from 'axios'
import PropTypes from 'prop-types'
import * as React from 'react'
const Counterpart = require('@gandi/counterpart').Instance

const DomHelper = require('../../../client/clientjs/dom-helper')

const translate = new Counterpart()
translate.registerTranslations('en', require('./i18n/en'))
translate.registerTranslations('fr', require('./i18n/fr'))

function closeModal() {
  DomHelper.removeClass(DomHelper.query('#modal-register-contest'), 'active')
}

class RegisterButton extends React.Component {
  constructor() {
    super()
    this.state = {
      loading: false,
    }

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillMount() {
    const { appConfig } = this.props
    if (appConfig.locale.identifierShort !== translate.getLocale()) {
      translate.setLocale(appConfig.locale.identifierShort)
    }
  }

  handleSubmit() {
    const { contestId, isLoggedIn } = this.props
    if (!isLoggedIn) {
      DomHelper.addClass(DomHelper.query('#modal-signup'), 'active')
      closeModal()
      return
    }
    const { loading } = this.state
    if (loading) {
      return
    }
    this.setState({ loading: true }, () => {
      request
        .post(`/api/contests/${contestId}/register`)
        .then(() => {
          window.location.reload()
        })
        .catch(err => {})
    })
  }

  render() {
    const { loading } = this.state
    const { contestDefautToPreRegister } = this.props

    return (
      <div>
        <button type="button" onClick={this.handleSubmit} className={`btn btn-primary ${loading ? 'loading' : ''}`}>
          <b>{contestDefautToPreRegister ? 'Pré-inscription' : "Je m'inscris !"}</b>
        </button>
      </div>
    )
  }
}

RegisterButton.propTypes = {
  appConfig: PropTypes.object.isRequired,
  contestId: PropTypes.string.isRequired,
  contestDefautToPreRegister: PropTypes.bool,
  isLoggedIn: PropTypes.bool.isRequired,
}

RegisterButton.defaultProps = {
  contestDefautToPreRegister: false,
}

module.exports = RegisterButton
